import AsyncStorage from '@react-native-async-storage/async-storage';
import { clientConfigPath } from '../../config/Constant';
import { setRenderFlashMessage } from './appConfigAction';

export const getGuestRequestList = (groupId) => {
  return async (dispatch) => {

    try {
      const response = await clientConfigPath.post('/serviceGroupDetails/get', {
        header: {
          serviceGroupId: groupId,
        },
        payload: {},
      });

      if (response.data.payload?.requestMaster?.length > 0 || response.data.payload?.length > 0) {
        return { status: "SUCCESS", response: response.data.payload }
      } else {
        return { status: "ERROR", message: "No data available at the moment. Please check back later." }
      }

    } catch (error) {

      return { status: "ERROR", message: "Something went wrong" }
    }

  };

};


export const sendGuestRequest = (requestDetails) => {

  return async (dispatch, getState) => {

    const { currentGuestDetails } = getState().guestDetailsSlice;
    const { bookingData } = getState().checkInSlice.bookingStatus;

    const sessionToken = await AsyncStorage.getItem("sessionToken");

    const body_header = {
      dataSource: "guestJourney",
      guestEmail: currentGuestDetails?.guestProfile?.email || "",
      guestToken: currentGuestDetails?.guestToken || "",
      locationId: currentGuestDetails?.location || "",
      loggedinGuestToken: currentGuestDetails?.guestToken || "",
      sessionToken: sessionToken
    }

    const body_payload = {
      reservationNumber: currentGuestDetails?.reservationNumber || bookingData?.reservationNumber,
      qualityPlusRequest: requestDetails
    }


    try {
      if (currentGuestDetails.reservationNumber || bookingData?.reservationNumber) {

        const response = await clientConfigPath.post("/qualityPlus/request", {
          header: body_header,
          payload: body_payload,
        });

        console.log("request API response:", response);
        const status = response?.data?.header?.status?.code;

        if (status == "SUCCESS") {
          dispatch(setRenderFlashMessage(true, { type: "success", message: response?.data?.header?.status?.msg || "Request placed successfully!!" }));
          return { status: "SUCCESS" };
        } else {
          dispatch(setRenderFlashMessage(true, { type: "danger", message: response?.data?.header?.status?.msg || "Something went wrong" }));
          return { status: "ERROR", message: response?.data?.header?.status?.msg || "Something went wrong" };
        }
      } else {
        dispatch(setRenderFlashMessage(true, { type: "danger", message: "Reservation number not found" }));
        return { status: "ERROR", message: "Reservation number not found" };
      }
    } catch (error) {
      console.error("Error in request API:", error);
      dispatch(setRenderFlashMessage(true, { type: "danger", message: error.response?.data?.header?.status?.msg || "Something went wrong" }));
      return { status: "ERROR", message: error.response?.data?.header?.status?.msg || "Something went wrong" };
    }
  }
}
